import { lazyLoad } from 'utils/loadable';

export const ProfileHomePage = lazyLoad(
  () => import('./index'),
  module => module.ProfileHomePage,
);
